module.exports = __webpack_public_path__ + "static/media/olx-header.fc6dd4dd.jpg";